var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgFinancial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 75,
    viewBox: "0 0 59 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 75,
    rx: 2,
    fill: "#FFEADB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 46,
    width: 28,
    height: 4,
    rx: 1,
    fill: "#FF9D5A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 39,
    width: 28,
    height: 4,
    rx: 1,
    fill: "#FF9D5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7712 48.0949C16.8296 48.0949 17.7217 47.6766 18.4474 46.84L20.0048 48.2915C19.5008 48.9064 18.8758 49.3751 18.1299 49.6977C17.3941 50.0202 16.5675 50.1815 15.6502 50.1815C14.7733 50.1815 13.9568 50.0253 13.2008 49.7128C12.4549 49.4003 11.8198 48.9568 11.2957 48.3822C10.7715 47.8077 10.3935 47.1424 10.1617 46.3864H8.45312V45.1163H9.93489C9.92481 45.0256 9.91977 44.8895 9.91977 44.7081C9.91977 44.5266 9.92481 44.3905 9.93489 44.2998H8.45312V43.0297H10.1617C10.3935 42.2737 10.7715 41.6085 11.2957 41.0339C11.8198 40.4593 12.4549 40.0158 13.2008 39.7033C13.9568 39.3909 14.7733 39.2346 15.6502 39.2346C16.5675 39.2346 17.3941 39.3959 18.1299 39.7185C18.8758 40.041 19.5008 40.5047 20.0048 41.1095L18.4474 42.561C17.7116 41.7345 16.8195 41.3212 15.7712 41.3212C15.1059 41.3212 14.5112 41.4724 13.987 41.7748C13.4629 42.0772 13.0597 42.4955 12.7774 43.0297H16.6028V44.2998H12.3994C12.3894 44.3905 12.3843 44.5266 12.3843 44.7081C12.3843 44.8895 12.3894 45.0256 12.3994 45.1163H16.6028V46.3864H12.7774C13.0597 46.9206 13.4629 47.3389 13.987 47.6413C14.5112 47.9437 15.1059 48.0949 15.7712 48.0949Z",
    fill: "#FF9D5A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 53,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#FF9D5A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 60,
    width: 28,
    height: 4,
    rx: 1,
    fill: "#FF9D5A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 31,
    width: 12,
    height: 6,
    rx: 1,
    transform: "rotate(-90 13 31)",
    fill: "#FF9D5A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 31,
    width: 23,
    height: 6,
    rx: 1,
    transform: "rotate(-90 22 31)",
    fill: "#FF9D5A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 31,
    width: 17,
    height: 6,
    rx: 1,
    transform: "rotate(-90 31 31)",
    fill: "#FF9D5A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 31,
    width: 20,
    height: 6,
    rx: 1,
    transform: "rotate(-90 40 31)",
    fill: "#FF9D5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20.0517L35.445 26.0585C34.5898 26.5961 33.468 26.4117 32.83 25.6286L24.5729 15.4944C23.8933 14.6603 22.6756 14.5133 21.817 15.1617L10 24.0862",
    stroke: "#E62645",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 17.4516L45.3429 24L49 17L41 17.4516Z",
    fill: "#E62645"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFinancial);
export default __webpack_public_path__ + "static/media/imgFinancial.fc9c05e10418822ef9c5b32565971ea7.svg";
export { ForwardRef as ReactComponent };